import React from 'react';

interface ServiceStatusCardProps {
    carPlate: string;
}

const OnWayToDeliverStatusCard: React.FC<ServiceStatusCardProps> = ({ carPlate }) => {
    return (
        <div className="row d-flex flex-column-reverse flex-md-row justify-content-center align-items-center">
            <div className="col-md-6 my-md-5">
                <h1>En camino</h1>
                <h2>Placa: {carPlate}</h2>
                <p>Tu vehículo está en camino hacia el punto de entrega. Prepárate para recibirlo.</p>
            </div>
            <div className="col-md-6 my-5 p-1 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#ffffff44", borderRadius: '8px' }}>
                <img src="/assets/delivered_started.png" alt="Vehículo en camino" />
            </div>
        </div>
    );
};

export default OnWayToDeliverStatusCard;
